/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { DEFAULT_IMAGE_SETTINGS } from "cms/images/image-inpage-editor-v2/image-helpers";
import { isGuid } from "utils/empty-exists";

const migrateBannerimage = (payload) => {
    
    // TODO: remove code for old banner image pattern
    if (payload["banner-image"]) {
        const hasBannerImage = isGuid(payload?.banner_image?.image);
        const hasBannerImageString = isGuid(payload["banner-image"]);

        if (!hasBannerImage && hasBannerImageString) {
            payload.banner_image = {
                image: payload["banner-image"],
                settings: DEFAULT_IMAGE_SETTINGS
            };
        }
        delete payload["banner-image"];
    }
    
    return payload;
};

export { migrateBannerimage };
